import styled from 'styled-components';

import type { TrackerBarPositionVariant, TrackerBarVariant } from './types';

export const VerticalTrackerContainer = styled.div``;

export const VerticalTrackerStepContainer = styled.div<{
  isCurrent: boolean;
}>`
  display: flex;
  flex-direction: row;
  background-color: ${props => (props.isCurrent ? props.theme.colors.capsuleGray00 : null)};
  padding-left: ${props => props.theme.space.s5};
  padding-right: ${props => props.theme.space.s5};
`;

export const VerticalProgressBarContainer = styled.div<{
  position: TrackerBarPositionVariant;
}>`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  padding-top: ${props => (props.position === 'first' ? props.theme.space['3.0'] : null)};
`;

export const VerticalProgressBarInfoContainer = styled.div<{
  position: TrackerBarPositionVariant;
}>`
  display: flex;
  flex-direction: column;
  padding-top: ${props => props.theme.space.s5};
  padding-bottom: ${props => (props.position !== 'last' ? props.theme.space.s5 : null)};
  padding-left: ${props => props.theme.space.s4};
`;

export const HorizontalTrackerContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const HorizontalTrackerStepContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  align-items: center;
  &:last-child {
    flex-grow: 0;
  }
`;

export const TopLine = styled.div<{
  variant: TrackerBarVariant;
  position: TrackerBarPositionVariant;
}>`
  width: 4px;
  background-color: ${props => {
    switch (props.variant) {
      case 'active':
        return props.theme.colors.capsuleGreen60;
      case 'inactive':
        return props.theme.colors.capsuleGray50;
      case 'inactiveCurrent':
        return props.theme.colors.capsuleGray50;
      case 'future':
        return props.theme.colors.capsuleGray10;
      default:
        return props.theme.colors.transparent;
    }
  }};
  height: ${props => props.theme.space['3.0']};
`;

export const CircleContainer = styled.div`
  width: ${props => props.theme.space['1.0']};
  height: ${props => props.theme.space['1.0']};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Circle = styled.div<{
  variant: TrackerBarVariant;
}>`
  box-sizing: content-box !important;
  border: ${props => (props.variant !== 'future' ? 'none' : `2px solid ${props.theme.colors.capsuleGray10}`)};
  border-radius: 50%;
  background: ${props => {
    switch (props.variant) {
      case 'active':
        return props.theme.colors.capsuleGreen60;
      case 'inactive':
        return props.theme.colors.capsuleGray50;
      case 'inactiveCurrent':
        return props.theme.colors.capsuleGray50;
      case 'future':
        return props.theme.colors.transparent;
      default:
        return props.theme.colors.transparent;
    }
  }};
  width: ${props => (props.variant !== 'future' ? props.theme.space.s3 : props.theme.space['1.0'])};
  height: ${props => (props.variant !== 'future' ? props.theme.space.s3 : props.theme.space['1.0'])};
  position: absolute;
`;

export const BottomLine = styled.div<{
  variant: TrackerBarVariant;
  isCurrent: boolean;
}>`
  width: 4px;
  background-color: ${props => {
    switch (props.variant) {
      case 'active':
        return props.theme.colors.capsuleGreen60;
      case 'inactive':
        return props.theme.colors.capsuleGray50;
      case 'inactiveCurrent':
        return props.theme.colors.capsuleGray10;
      case 'future':
        return props.theme.colors.capsuleGray10;
      default:
        return props.theme.colors.transparent;
    }
  }};
  background-image: ${props =>
    props.variant === 'active' && props.isCurrent
      ? `linear-gradient(${props.theme.colors.capsuleGreen60}, ${props.theme.colors.capsuleGreen50})`
      : null};
  flex-grow: 1;
  border-bottom-right-radius: ${props => props.variant === 'active' && props.isCurrent && props.theme.radii.large};
  border-bottom-left-radius: ${props => props.variant === 'active' && props.isCurrent && props.theme.radii.large};
  box-shadow: 0px 4px ${props => props.theme.colors.capsuleGray10};
`;

export const LeftLine = styled.div<{
  variant: TrackerBarVariant;
  isCurrent: boolean;
}>`
  height: 4px;
  background-color: ${props => {
    switch (props.variant) {
      case 'active':
        return props.theme.colors.capsuleGreen60;
      case 'inactive':
        return props.theme.colors.capsuleGray50;
      case 'inactiveCurrent':
        return props.theme.colors.capsuleGray10;
      case 'future':
        return props.theme.colors.capsuleGray10;
      default:
        return props.theme.colors.transparent;
    }
  }};
  flex-grow: 1;
  background-image: ${props =>
    props.variant === 'active' && props.isCurrent
      ? `linear-gradient(to right, ${props.theme.colors.capsuleGreen60}, ${props.theme.colors.capsuleGreen50})`
      : null};
  border-top-right-radius: ${props => props.variant === 'active' && props.isCurrent && props.theme.radii.large};
  border-bottom-right-radius: ${props => props.variant === 'active' && props.isCurrent && props.theme.radii.large};
  box-shadow: 4px 0px ${props => props.theme.colors.capsuleGray10};
`;

export const RightLine = styled.div<{
  variant: TrackerBarVariant;
  isCurrent: boolean;
}>`
  height: 4px;
  background-color: ${props => {
    switch (props.variant) {
      case 'active':
        return props.isCurrent ? props.theme.colors.capsuleGray10 : props.theme.colors.capsuleGreen60;
      case 'inactive':
        return props.theme.colors.capsuleGray50;
      case 'inactiveCurrent':
        return props.theme.colors.capsuleGray10;
      case 'future':
        return props.theme.colors.capsuleGray10;
      default:
        return props.theme.colors.transparent;
    }
  }};
  flex-grow: 1;
`;
